export default __webpack_public_path__ + "static/media/cardfront.ead84381.jpg";